import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import css from './Header.module.scss';

export const TradeLink = props => {
  const [id, setId] = useState(null);
  const [url, setUrl] = useState(null);
  const [name, setName] = useState(null);

  useEffect(() => {
    if (props && props.id && props.url && props.name) {
      setId(props.id);
      setUrl(props.url);
      setName(props.name);
    }
  }, [props, props.id, props.url, props.name]);

  let link = undefined;

  if (id !== null) {
    if (props.elementType === 'mobileMenu') {
      link = (
        <a
          id={`tradelink-${id}`}
          className={css['App-mobile-header-dropdown-link']}
          target='_blank'
          rel='noopener noreferrer'
          href={url}
        >
          <span className={css['App-mobile-header-dropdown-item']}>{name}</span>
        </a>
      );
    } else {
      link = (
        <a id={`tradelink-${id}`} target='_blank' rel='noopener noreferrer' href={url}>
          {name}
        </a>
      );
    }
  }

  return link;
};

TradeLink.propTypes = {
  id: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default TradeLink;
